module.exports = __webpack_public_path__ + "assets/img/worldviewImg-6e99555a.png";